import { styled } from '@stitches/react';

export const RightSlot = styled('div', {
  marginLeft: 'auto',
  paddingLeft: 20,
});
